import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private readonly _loading = signal(false);
  private pendingRequests = 0;
  readonly loading = this._loading.asReadonly();
  private skipAutoSave = false;

  show(): void {
    this.pendingRequests += 1;
    this._loading.set(true);
  }

  hide(): void {
    this.pendingRequests = Math.max(0, this.pendingRequests - 1);
    this._loading.set(this.pendingRequests > 0);
  }

  reset(): void {
    this.pendingRequests = 0;
    this._loading.set(false);
  }

  setSkipAutoSave(enabled: boolean): void {
    this.skipAutoSave = !!enabled;
  }

  isSkipAutoSave(): boolean {
    return this.skipAutoSave;
  }
}
